import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { OrbitFormClaimService } from '../../features/orbit/book-claim/services/orbit-form-claim.service';
import { AppInfo } from '../environment';

export namespace OrbitUtils {
  let router: Router | undefined;
  let planNumber: string | undefined;
  let orbitFormClaimService: OrbitFormClaimService;

  export function initialise(
    _router: Router,
    _planNumber: string,
    _orbitFormClaimService: OrbitFormClaimService
  ): void {
    router = _router;
    planNumber = _planNumber;
    orbitFormClaimService = _orbitFormClaimService;
  }

  export function sendUserToErrorPage(error: HttpErrorResponse): void {
    orbitFormClaimService?.setFormError(error);
    const orbitCode = error?.error?.status;
    const isService = orbitFormClaimService?.pendingSessionClaimType() === 'SERVICE';
    if (isService && orbitCode === 'NC003') {
      router?.navigate(['/', planNumber, 'orbit', 'service-not-due']);
    } else {
      router?.navigate(['/', planNumber, 'orbit', 'error']);
    }
  }

  export function sendUserBackToMMRPage(): void {
    window.location.href = `${AppInfo.Environment.claimsURL}/my-plans/${planNumber}/claims`;
  }
}
